import { useQuery } from 'react-query';
import { chrApi } from '../../api/api';

export const usePatientByChrId = (chrPatientId, onSuccess) => {
  return useQuery('fetchPatient', () => chrApi('get', `patient/${chrPatientId}`, null, null).then((res) => res.data), {
    enabled: !!chrPatientId,
    onSuccess: onSuccess,
    cacheTime: 2000,
  });
};
